import { render, staticRenderFns } from "./Brand.vue?vue&type=template&id=e3468c32"
import script from "./Brand.vue?vue&type=script&lang=ts"
export * from "./Brand.vue?vue&type=script&lang=ts"
import style0 from "./Brand.vue?vue&type=style&index=0&id=e3468c32&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports